/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ResourceRecommendationITSMEvent {
    getFixupPrototypeFunction() { return ResourceRecommendationITSMEvent.fixupPrototype; }

    static newInstance(model: Partial<ResourceRecommendationITSMEvent>): ResourceRecommendationITSMEvent {
        let obj = Object.assign(new ResourceRecommendationITSMEvent(), model);
        ResourceRecommendationITSMEvent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ResourceRecommendationITSMEvent>): ResourceRecommendationITSMEvent {
        if (!model) return null;
        return ResourceRecommendationITSMEvent.newInstance(<ResourceRecommendationITSMEvent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ResourceRecommendationITSMEvent) {
        if (!obj) return;

        models.ResourceRecommendationITSMEvent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ResourceRecommendationITSMEvent): boolean {
        Object.setPrototypeOf(obj, ResourceRecommendationITSMEvent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Name of the integrated ITSM service where the event was raised (e.g. ServiceNow, Jira)
     */
    service: models.IntegratedToolName;

    /**
     * Service account ID associated with the ITSM integration
     */
    service_account_id: string;

    /**
     * Type of ITSM event raised for the remediation (e.g. incident creation)
     */
    event_type: string;

    /**
     * Status of the ITSM event raised for the remediation (e.g. success, failure)
     */
    status: models.ITSMEventStatus;

    /**
     * Incident number created in the integrated ITSM tool for the resource
     */
    incident_id: string;

}
